import { inject, Injectable } from "@angular/core";
import { ApiKey } from "@models/common.model";
import { Api } from "@services/api.service";

@Injectable({
	providedIn: 'root'
})
export class ApiKeyService{
	readonly api=inject(Api);

	apiKeyList(){
		return this.api.get<ApiKey[]>(`/api-keys`);
	}

	addApiKey(app: string){
		return this.api.post<ApiKey>(`/api-keys`, {app});
	}

	disabledApiKey(ident: string){
		return this.api.get<ApiKey>(`/api-keys/${ident}/disabled`);
	}

	removeApiKey(ident: string){
		return this.api.delete<ApiKey>(`/api-keys/${ident}`);
	}
}